import BankAccountButtonView from 'app/views/bank_account_button_view';
import CreditCardButtonView from 'app/views/credit_card_button_view';
import Base from 'app/views/base';

import tmpl from 'templates/payment_method_type_selection';

export default Base.extend({
  compiledTemplate: tmpl,

  events: {},

  initialize(options) {
    this.priority = options.priority;
    this.addSubview('creditCardButton', '.credit_card_button',
      new CreditCardButtonView({ model: this.model, priority: this.priority })
    );
    this.addSubview('bankAccountButton', '.bank_account_button',
      new BankAccountButtonView({ model: this.model, priority: this.priority })
    );
  },

  context() {
    return {
      isPrimary: this.priority === 'primary',
    };
  },
});



// WEBPACK FOOTER //
// ./app/views/payment_method_type_selection_view.js